import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import * as s from "../FilterStyled";
import { Table } from "antd";
import type { TableColumnsType, TableProps } from "antd";
import {
  DashboardFilterRecorderData,
  DashboardFilterRecorderResult,
} from "api/interfaces/dashboardInterface.interface";
import Type from "components/atoms/text/labels/Type";
import { matchStringSearchKeyword } from "utils/functions";
import { mobileMax } from "components/MediaQuery";
import { useMediaQuery } from "react-responsive";

type Props = {
  searchInput: string;
  recorderData: DashboardFilterRecorderData[];
  recorderRowSelection: React.Key[];
  setRecorderRowSelection: Dispatch<SetStateAction<React.Key[]>>;
};

export function RecorderFilterTable(props: Props) {
  // console.log(props.recorderRowSelection);

  const isMobile = useMediaQuery({ maxWidth: mobileMax });
  const onSelectChange = (selectedKeys: React.Key[]) => {
    // console.log("selectedRowKeys changed: ", selectedKeys);
    props.setRecorderRowSelection(selectedKeys);
  };
  const rowSelection = {
    selectedRowKeys: props.recorderRowSelection,
    onChange: onSelectChange,
    hideSelectAll: true,
    preserveSelectedRowKeys: true,
  };
  const columns: TableColumnsType<DashboardFilterRecorderData> = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (text, row) => (
        <span className="left">
          <Type
            type={text}
            licenseType={row.licenseType}
            // isCloudCam={row.isCloudCam} //system 단위에서만 표시 (recorder 단위에서는 표시하지 않음: 추후 표시해달라고할 수 있음 서버에는 값 옮)
          />
        </span>
      ),
      width: 90,
    },
    {
      title: "Title",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Location",
      dataIndex: "locationName",
      key: "locationName",
      hidden: isMobile,
    },
  ];

  const data: DashboardFilterRecorderData[] = useMemo(() => {
    return props.recorderData.filter((rec) => {
      return (
        matchStringSearchKeyword(rec.type, props.searchInput) ||
        matchStringSearchKeyword(rec.name, props.searchInput) ||
        matchStringSearchKeyword(
          rec.locationName ? rec.locationName : "",
          props.searchInput
        )
      );
    });
  }, [props.searchInput, props.recorderData]);

  useEffect(() => {}, [props.recorderRowSelection]);

  return (
    <s.RecorderTableContainer>
      <Table
        rowKey="recorderId"
        columns={columns}
        dataSource={data}
        pagination={false}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
      />
    </s.RecorderTableContainer>
  );
}
